import { gsap } from 'gsap';

const $raiserElems = [...document.querySelectorAll('.raiser')];


class Raiser {
    constructor() {
        this.DOM = { $raiserElems: [...document.querySelectorAll('.raiser')] }
        this.DOM.raiserWrappers = []
        this.fireOnce = true;
        this.observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    gsap.to(entry.target, {
                        y: 0,
                        opacity: 1,
                        duration: 1.25,
                    })
                    if (this.fireOnce) this.observer.unobserve(entry.target)
                } else {
                    gsap.set(entry.target, {
                        y: 50,
                        opacity: 0
                    })
                }
            });
        }, {

        });
        this.init()
    }
    init() {
        this.initObervation()
        // this.wrapRaisers()

    }
    // wrapRaisers() {
    // Function could help with reveal animations
    //     this.DOM.$raiserElems.forEach(el => {
    //         const wrapper = document.createElement('div');
    //         wrapper.classList.add('raiser-wrapper');
    //         el.parentNode.insertBefore(wrapper, el);
    //         wrapper.appendChild(el);
    //         this.DOM.raiserWrappers.push(wrapper)
    //     });
    // }
    initObervation() {
        this.DOM.$raiserElems.forEach(elem => this.observer.observe(elem))
    }
}

const myObserver = new (Raiser)




// const raiserObserver = new IntersectionObserver((entries, observer) => {
//     entries.forEach(entry => {
//         if (entry.isIntersecting) {
//             console.log(entry.target)
//         }

//         // Each entry describes an intersection change for one observed
//         // target element:
//         //   entry.boundingClientRect
//         //   entry.intersectionRatio
//         //   entry.intersectionRect
//         //   entry.isIntersecting
//         //   entry.rootBounds
//         //   entry.target
//         //   entry.time
//     });


// }, {

// });

